import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Drawer, useMediaQuery, useTheme, } from "@mui/material";
import { Icon } from "@iconify/react";
import { between } from "../style/style";
import { SIconButton } from "../buttons";
import { SButton } from "../buttons/SButton";
const FDialog = ({ isOpen, onClose, onSubmit, loading = false, title, children, confirmText = "Confirm", cancelText = "Cancel", maxWidth = "md", disableActions = false, fullHeight = false, actions, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const ActionButtons = () => {
        if (disableActions)
            return null;
        if (actions)
            return React.createElement(DialogActions, { sx: { px: { xs: 1.5, sm: 3 }, pb: { xs: 1.5, sm: 3 }, pt: 0 } }, actions);
        return (React.createElement(DialogActions, { sx: { padding: { xs: '16px !important', sm: '24px !important' } } },
            React.createElement(SButton, { onClick: onClose, size: "medium", variant: "soft", disabled: loading, fullWidth: isMobile }, cancelText),
            React.createElement(SButton, { onClick: onSubmit, variant: "contained", size: "medium", type: "submit", disabled: loading, fullWidth: isMobile }, confirmText)));
    };
    const Header = () => (React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { padding: { xs: "12px 12px", sm: "16px 24px" }, borderBottom: "1px solid #eee" }) },
        React.createElement(Typography, { variant: "h6", fontWeight: 500 }, title),
        React.createElement(SIconButton, { onClick: onClose, title: "Close", size: "small", colorVariant: "primary", showBackground: false },
            React.createElement(Icon, { icon: "mingcute:close-line" }))));
    if (isMobile) {
        // Drawer on mobile
        return (React.createElement(Drawer, { anchor: "bottom", open: isOpen, onClose: onClose, slotProps: {
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(22, 28, 36, 0.4)",
                    },
                },
            }, sx: {
                "& .MuiDrawer-paper": {
                    backgroundColor: "#F9FAFB",
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    maxHeight: fullHeight ? "95dvh" : "90dvh",
                    paddingBottom: "env(safe-area-inset-bottom)",
                    display: "flex",
                    flexDirection: "column",
                },
            } },
            React.createElement(Box, { sx: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    pt: 1.5,
                    pb: 1,
                } },
                React.createElement(Box, { sx: {
                        width: 40,
                        height: 4,
                        backgroundColor: "#DFE3E8",
                        borderRadius: 2,
                    } })),
            React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { px: { xs: 1.5, sm: 3 }, pb: 2, pt: 1 }) },
                React.createElement(Typography, { variant: "h4", color: "primary.main", fontWeight: 500 }, title)),
            React.createElement(Box, { sx: {
                    px: { xs: 1.5, sm: 3 },
                    overflowY: "auto",
                    flex: 1,
                    WebkitOverflowScrolling: "touch",
                } }, children),
            ActionButtons()));
    }
    // Dialog for desktop/tablet
    return (React.createElement(Dialog, { open: isOpen, onClose: (event, reason) => {
            if (reason !== "backdropClick") {
                onClose();
            }
        }, slotProps: {
            backdrop: {
                sx: {
                    backgroundColor: "rgba(22, 28, 36, 0.4)",
                },
            },
        }, sx: {
            "& .MuiDialog-paper": Object.assign({ backgroundColor: "#F9FAFB" }, (fullHeight && {
                height: "90dvh",
                maxHeight: "90dvh",
                display: "flex",
                flexDirection: "column",
            })),
        }, maxWidth: maxWidth, fullWidth: true },
        React.createElement(DialogTitle, { sx: Object.assign(Object.assign({}, between), { padding: { xs: "12px 12px 0px 12px", sm: "24px 24px 0px 24px" } }) },
            React.createElement(Typography, { variant: "h4", color: "primary.main", fontWeight: 500 }, title)),
        React.createElement(DialogContent, { sx: { padding: { xs: '12px 12px', sm: '12px 24px' } } },
            React.createElement(Box, { sx: { pt: 1, pb: disableActions ? 2 : 0 } }, children)),
        ActionButtons()));
};
export default FDialog;
